<template>
  <div class="event-hero">
    <!-- Faixa de tipo do evento -->
    <div class="event-type-badge">
      <i class="fas fa-star me-1"></i>{{ event.event_type }}
    </div>

    <!-- Conteúdo principal -->
    <div class="event-hero-inner">
      <!-- Foto -->
      <div class="event-hero-photo">
        <img v-if="event.baby_photo" :src="event.baby_photo" :alt="event.baby_name" />
        <div v-else class="event-hero-photo-placeholder">
          <i class="fas fa-gift"></i>
        </div>
      </div>

      <!-- Texto -->
      <div class="event-hero-info">
        <p class="event-hero-label">Lista de presentes de</p>
        <h2 class="event-hero-name">{{ event.baby_name }}</h2>
        <p class="event-hero-sub">Escolha um presente e faça parte desse momento especial 🎁</p>
        <div v-if="rsvpConfirmed" class="event-hero-rsvp-badge">
          <i class="fas fa-check-circle"></i> Presença confirmada!
        </div>
      </div>

      <!-- Botão Ver Convite -->
      <button
        v-if="showInviteButton"
        class="event-hero-invite-btn"
        @click="$emit('invite-click')"
        aria-label="Ver convite"
      >
        <i class="fas fa-envelope-open-text"></i>
        <span class="event-hero-invite-btn__label">Ver convite</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CartHeader',
  props: {
    event: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    rsvpConfirmed: {
      type: Boolean,
      default: false,
    },
    showInviteButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['invite-click'],
};
</script>

<style scoped>
.event-hero {
  --primary: var(--event-primary, #ff50a3);

  position: relative;
  background: color-mix(in srgb, var(--event-primary, #ff50a3) 5%, #ffffff);
  border: 1px solid color-mix(in srgb, var(--event-primary, #ff50a3) 25%, #e8e8e8);
  box-shadow: 0 2px 12px color-mix(in srgb, var(--event-primary, #ff50a3) 10%, rgba(0,0,0,0.06));
  border-radius: 1rem;
  padding: 1.25rem 1.25rem 1rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
}

/* Detalhe decorativo de fundo */
.event-hero::before {
  content: '';
  position: absolute;
  top: -30px;
  right: -30px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--event-primary, #ff50a3) 7%, transparent);
  pointer-events: none;
}

.event-hero::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: -20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(130, 80, 255, 0.05);
  pointer-events: none;
}

/* Badge tipo do evento */
.event-type-badge {
  display: inline-flex;
  align-items: center;
  background-color: color-mix(in srgb, var(--event-primary, #ff50a3) 8%, #ffffff);
  border: 1px solid color-mix(in srgb, var(--event-primary, #ff50a3) 30%, #fff);
  color: var(--primary);
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 0.2rem 0.6rem;
  border-radius: 999px;
  margin-bottom: 0.85rem;
}

/* Layout interno */
.event-hero-inner {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Foto */
.event-hero-photo {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid #fff;
  box-shadow: 0 2px 12px color-mix(in srgb, var(--event-primary, #ff50a3) 20%, transparent);
}

.event-hero-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.event-hero-photo-placeholder {
  width: 100%;
  height: 100%;
  background: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
}

.event-hero-photo-placeholder i {
  color: #fff;
  font-size: 1.5rem;
}

/* Textos */
.event-hero-info {
  flex: 1;
  min-width: 0;
}

.event-hero-label {
  font-size: 0.75rem;
  color: #9a9db5;
  margin: 0 0 0.1rem;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  font-weight: 500;
}

.event-hero-name {
  font-size: 1.35rem;
  font-weight: 800;
  color: #32355d;
  margin: 0 0 0.25rem;
  line-height: 1.2;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.event-hero-sub {
  font-size: 0.8rem;
  color: #a0a5b8;
  margin: 0;
  line-height: 1.4;
}

.event-hero-rsvp-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.5rem;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.35);
  color: #16a34a;
  font-size: 0.72rem;
  font-weight: 700;
}

/* Botão Ver Convite */
.event-hero-invite-btn {
  flex-shrink: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  background: color-mix(in srgb, var(--event-primary, #ff50a3) 10%, #ffffff);
  border: 1px solid color-mix(in srgb, var(--event-primary, #ff50a3) 30%, #e8e8e8);
  color: var(--event-primary, #ff50a3);
  border-radius: 0.75rem;
  padding: 0.5rem 0.75rem;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1;
}

.event-hero-invite-btn:hover {
  background: color-mix(in srgb, var(--event-primary, #ff50a3) 18%, #ffffff);
  border-color: color-mix(in srgb, var(--event-primary, #ff50a3) 50%, #e8e8e8);
}

.event-hero-invite-btn i {
  font-size: 1.1rem;
}

.event-hero-invite-btn__label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

@media (max-width: 575.98px) {
  .event-hero-name {
    font-size: 1.15rem;
  }

  .event-hero-photo {
    width: 68px;
    height: 68px;
  }

  .event-hero-invite-btn__label {
    display: none;
  }
}
</style>
